import { StyledDiv } from './StyledComponents';
import cx from 'classnames';
import { forwardRef } from 'react';

type Props = WithChildren<{ classNames?: string }>;

const SkeletonContainer = forwardRef<HTMLDivElement, Props>(({ children, classNames = '' }, ref) => (
  <StyledDiv aria-label="loading" role="status" className={cx('Skeleton-Container', classNames)} ref={ref}>
    {children}
  </StyledDiv>
));

export default SkeletonContainer;
